export const removeVersionFromPolicyNumber = (policyNumber: string): string => policyNumber.split("-")[0];
